document.addEventListener('DOMContentLoaded', (event) => {
    // console.log('DOM fully loaded and parsed');
    const scrollBtn = document.getElementById("scrollToTopBtn");
    
      window.addEventListener("scroll", () => {
        const foldHeight = window.innerHeight;
    
        if (window.scrollY > foldHeight) {
          scrollBtn.classList.add("show");
        } else {
          scrollBtn.classList.remove("show");
        }
      });
    
      scrollBtn.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
});

